export function getPathKey(
  level: number | string,
  path?: string | number,
): string {
  // path: ".../topic/react/router"
  // level:1 -> topics
  // level:2 -> react
  // level:3 -> route
  const locationPath = window.location.pathname;
  return locationPath.split('/')[level || 0];
}

export function getEditPagePath() {
  // path: ".../{path}-edit/..."
  return getPathKey(1).split('-')[0];
}

export function getOriginPathKey(
  level: number | string,
  path?: string | number,
): string {
  const locationPath = window.location.pathname;
  const segment = locationPath.split('/')[Number(level) || 0] || '';
  // 숫자 제거: 예) "posting1" -> "posting"
  return segment.replace(/\d+$/, '');
}
